import { useSearchParams } from 'react-router';

/**
 * 355 (FR-011): a list filter carried in the address, so a dashboard count can open the list already narrowed. Only a
 * value in `allowed` counts; anything else reads as no filter, never as a request for everything. Clearing removes it
 * from the address, so the list returns to what it shows without it.
 */
export function useUrlFilter<T extends string>(
  name: string,
  allowed: readonly T[],
): [T | '', () => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get(name) ?? '';
  const value = (allowed as readonly string[]).includes(raw) ? (raw as T) : '';
  const clear = () => {
    const next = new URLSearchParams(params);
    next.delete(name);
    setParams(next, { replace: true });
  };
  return [value, clear];
}
